import { render, staticRenderFns } from "./AdminFieldTimestampReadable.vue?vue&type=template&id=37583e92&"
import script from "./AdminFieldTimestampReadable.vue?vue&type=script&lang=js&"
export * from "./AdminFieldTimestampReadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports